import Vue from 'vue';
import VueRouter from 'vue-router';
import routers  from './route';
import { Loading } from 'element-ui';
import { setTitle } from 'src/assets/js/util';
import { sessionStorage,localStorage } from '../assets/js/storage';
import Cookies from 'js-cookie'

Vue.use(VueRouter);

const routerConfig = {
  mode: 'hash', //hash--有#   history--无#
  linkActiveClass: 'active',
  routes: routers
};

const router = new VueRouter(routerConfig);

router.beforeEach((to, from, next) => {
  let isLogin = Cookies.get('token')?true:false;
  let {path,name,query} = to;
  console.log('to',to)
  console.log('是否登录:',isLogin)
  // 设置window.document.title 的名称
  setTitle(to.meta.title || '桂软产品');
  

  if (name) {
          
      if (!isLogin) {
          //未登录的用户
          if (path === '/register' || path === '/login' || path === '/findpass') {
            next();
          } else {
            next({
              path: '/login',
              query
            });
          }
      } else {
          //已登录用户
          if (path === '/login') {
            next({
              path: '/'
            }); 
          } else {
            next();
          }
      }
  } else {
    console.log("不存在")
    next({
      name: '404',
      replace: true
    });
  }


});

router.afterEach((to, from) => {
  // 解决某些情况下loading无法关闭的情况
  
});

// 跳转后滚动至顶部
router.afterEach((to, from) => {
  document.body.scrollTop=document.documentElement.scrollTop=0;
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js